module.exports = __webpack_public_path__ + "img/man-1.934ab19f.svg";